import React, { useContext, useEffect } from 'react';
import { AuthContext } from 'features/auth/context/Auth';
import { connect } from 'react-redux';
import Moment from 'moment';
import Loader from 'features/Loader/Loader';
import Header from './header';
import Status from './status';
import Info from './info';
import './profile.scss';
import { getFocusAreas } from '../ducks/trainerProfileActions';

const Profile = props => {
  const { currentUser } = useContext(AuthContext) || {};
  useEffect(() => {
    props.getFocusAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.uid]);

  let { trainer, focusAreasData, loadingTrainer } = props;

  let activeSince =
    trainer && trainer.created_at
      ? Moment(toDateTime(trainer.created_at.seconds * 1000).toString()).format(
          'MMMM DD, YYYY'
        )
      : '-';

  function toDateTime(s) {
    var t = new Date(1970, 0, 1); // Epoch
    t.setMilliseconds(s + 60 * 60 * 24);
    return t;
  }

  if (loadingTrainer) {
    return <Loader />;
  }

  return (
    <div className="profile">
      <div className="container">
        {trainer ? <Header trainer={trainer} /> : ''}
        <Status
          createdAt={activeSince}
          clientsNumber={
            trainer && trainer.number_of_clients
              ? trainer.number_of_clients
              : '0'
          }
        />
        <Info
          certifications={
            trainer && trainer.certifications ? trainer.certifications : ''
          }
          focus={trainer && (trainer.focus_areas || [])}
          focusAreasData={focusAreasData}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer,
    loadingTrainer: state.trainerProfileReducer.loading,
    focusAreasData: state.trainerProfileReducer.focusAreas
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFocusAreas: () => dispatch(getFocusAreas())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
